import React, { Component } from "react";
import { connect } from "react-redux";
import {
  FormGroup,
  ControlLabel,
  FormControl,
  Checkbox,
  Button,
} from "react-bootstrap";
import { ButtonStyle, Title } from "../Styles";
import CustomModal from "../Shared/Modal";
import { updateUser } from "../../redux/middleware/user";
import {
  MainContent,
  Section,
  Header,
  HeaderTitle,
} from "./Styles/Settings.style";
import { Loader } from "../Shared";

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      advisor: props.advisor,
      reports: props.reports,
      announcements: props.announcements,
      updates: props.updates,
      offers: props.offers,
      showEmailModal: false,
      showPasswordModal: false,
      email: "",
      password: "",
      currentPassword: "",
      confirmPassword: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    const { updateuserpending, notify } = this.props;
    if (updateuserpending && !nextProps.updateuserpending) {
      console.log(nextProps.user)
      if (nextProps.user.error) {
        notify("error", nextProps.updateUserError?.response?.data?.errors || "Something went wrong");
      } else {
        notify("success", nextProps.user.message);
      }
    }
  }

  handleChange = (e) => {
    const { name } = e.target;
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ [name]: value });
  };

  handleShowPasswordModal = () => {
    this.setState({ showPasswordModal: true });
  };

  handleShowEmailModal = () => {
    this.setState({ showEmailModal: true });
  };

  handleClose = () => {
    this.setState({ showEmailModal: false, showPasswordModal: false });
  };

  handleUpdate = (event) => {
    event.preventDefault();
    let updates = {};
    const { updateUser: updateUserAction } = this.props;
    const { email, password, currentPassword, confirmPassword } = this.state;
    email && (updates = { email });
    password &&
      (updates = {
        old_password: currentPassword,
        password,
        password_confirmation: confirmPassword,
      });
    updateUserAction(updates);

    this.setState({
      password: "",
      email: "",
      showPasswordModal: false,
      showEmailModal: false,
    });
  };

  modalFooter = () => (
    <>
      <Button onClick={this.handleClose}>Close</Button>
      <Button bsStyle="primary" type="submit">
        Save changes
      </Button>
    </>
  );

  render() {
    const { user, updateuserpending } = this.props;
    const {
      showEmailModal,
      showPasswordModal,
      email,
      advisor,
      reports,
      announcements,
      updates,
      offers,
      password,
      currentPassword,
      confirmPassword,
    } = this.state;

    return (
      <div style={{ opacity: updateuserpending ? 0.5 : 1 }}>
        <Loader fullScreen show={updateuserpending} vwidth="50vw" />
        <Header>
          <HeaderTitle>Account Settings</HeaderTitle>
        </Header>
        <MainContent>
          <Section style={{ paddingTop: 110 }}>
            <Title>Email</Title>
            <div>
              {user && user.email} &nbsp;
              <ButtonStyle
                to="/"
                className="btn btn-primary btn_apply white_bg"
                onClick={this.handleShowEmailModal}
              >
                Change Email
              </ButtonStyle>
            </div>
          </Section>
          <Section>
            <Title>Password</Title>
            <div>
              <ButtonStyle
                to="/"
                className="btn btn-primary btn_apply white_bg"
                onClick={this.handleShowPasswordModal}
              >Change Password</ButtonStyle>
            </div>
          </Section>
          <Section>
            <Title>Email Notifications</Title>
            <div>
              <Checkbox
                name="advisor"
                value={advisor}
                onChange={this.handleChange}
              >
                Subscribe to QuirkyCoders free weekly newsletter to receive tech
                news and career advice.
              </Checkbox>
              <Checkbox
                name="reports"
                value={reports}
                onChange={this.handleChange}
              >
                Subscribe to QuirkyCoders free monthly newsletter on trends in
                the tech job market, skills and salaries.
              </Checkbox>
              <Checkbox
                name="announcements"
                value={announcements}
                onChange={this.handleChange}
              >
                Subscribe to Announcents about new QuirkyCoders features, member
                surveys and promotions.
              </Checkbox>

              <Checkbox
                name="updates"
                value={updates}
                onChange={this.handleChange}
              >
                Subscribe to receive custom emails about your resume, job alerts
                and recommended QuirkyCoders services.
              </Checkbox>
              <Checkbox
                name="offers"
                value={offers}
                onChange={this.handleChange}
              >
                Subscribe to receive special offers from select QuirkyCoders
                partners.
              </Checkbox>
            </div>
          </Section>
        </MainContent>
        <form onSubmit={this.handleUpdate}>
          <CustomModal
            show={showEmailModal}
            footer={this.modalFooter}
            title="Change Email"
          >
            <FormGroup controlId="email">
              <ControlLabel>Email:</ControlLabel>
              <FormControl
                type="email"
                value={email}
                name="email"
                placeholder="Enter new email"
                onChange={this.handleChange}
                required
              />
            </FormGroup>
          </CustomModal>
        </form>
        <form onSubmit={this.handleUpdate}>
          <CustomModal
            show={showPasswordModal}
            footer={this.modalFooter}
            title="Change Password"
          >
            <FormGroup controlId="currentPassword">
              <ControlLabel>Current Password:</ControlLabel>
              <FormControl
                type="password"
                value={currentPassword}
                name="currentPassword"
                placeholder="Enter password"
                onChange={this.handleChange}
                required
              />
            </FormGroup>
            <FormGroup controlId="password">
              <ControlLabel>New Password:</ControlLabel>
              <FormControl
                type="password"
                value={password}
                name="password"
                placeholder="Enter password"
                onChange={this.handleChange}
                required
              />
            </FormGroup>
            <FormGroup controlId="confirmPassword">
              <ControlLabel>Confirm New Password:</ControlLabel>
              <FormControl
                type="password"
                value={confirmPassword}
                name="confirmPassword"
                placeholder="Enter password"
                onChange={this.handleChange}
                required
              />
            </FormGroup>
          </CustomModal>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.updateUser,
  updateuserpending: state.updateUser.pending,
  updateUserError: state.updateUser.error,
});

const mapDispatchToProps = (dispatch) => {
  return {
    updateUser: (data, id) => dispatch(updateUser(data, id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
